import React, { useContext, useState } from 'react';
import Context from '../../../../context/context';

const Email = (props) =>{

    const {state, dispatch} = useContext(Context);
    const [email, setEmail] = useState(state.email);
    const setEmailDispatch = data => dispatch({type:"SET_EMAIL", payload: data});
    const userEmail = props.email;

    const handleChange = (event) => {
        setEmail(event.target.value);
        setEmailDispatch(event.target.value);
    };

    return (
        <div>
        <input
        className='invitationInput emailInvitationInput'
        placeholder='אימייל *'
        id="email-input"
        name="email"
        required
        value={userEmail}
        onChange={handleChange}
      />
        </div> 
    )
}

export default Email;